import { render, staticRenderFns } from "./DirectUsers.vue?vue&type=template&id=2147458a&scoped=true"
import script from "./DirectUsers.vue?vue&type=script&lang=js"
export * from "./DirectUsers.vue?vue&type=script&lang=js"
import style0 from "./DirectUsers.vue?vue&type=style&index=0&id=2147458a&prod&scoped=true&lang=css"
import style1 from "./DirectUsers.vue?vue&type=style&index=1&id=2147458a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2147458a",
  null
  
)

export default component.exports